import MicTest from "./components/MicTest"
import Softphone from "./components/Softphone"
import SpeedTest from "./components/SpeedTest"

export default { Softphone, SpeedTest, MicTest }

// Uncomment below for local dev env testing
// const softphone = new Softphone()

// softphone.enableAutoTests = false // disable tests (enabled by default)
// softphone.on("register", () => {
//     softphone
//         .dial({
//             contact: {
//                 vendorcontactid: 123,
//                 firstname: "John",
//                 lastname: "Doe",
//                 phonenumber: "8888",
//                 addressline1: "5229 Caspian Springs Dr Unit 204",
//                 city: "Las Vegas",
//                 state: "NV",
//                 postalcode: "89120",
//                 country: "US",
//             },
//             propertyInfo: {
//                 img: "https://i.imgur.com/GNac9c1.png", // url of propery image
//                 address: "5229 Caspian Springs Dr Unit, New York, United States of America, 1111 - 1111",
//                 bedrooms: 2,
//                 bathrooms: 2,
//                 size: 1000,
//                 lotSize: 10000,
//             },
//         })
//         .catch(e => console.log(e)) //("8585551213", "8187437960");

//     // softphone.show()
// })
// softphone.on("hangup", () => {
//     console.log("call hangup callback called:>> ")
// })
// softphone.on("click_help_wanted", () => {
//     alert("click help wanted ")
// })
// softphone.on("click_contact_open", vendorcontactid => {
//     alert(`click contact open ${vendorcontactid}`)
// })
// softphone
//     .register("4b65266c-038c-4cc7-aeb8-664020a3d0e6", {
//         backendAPI: "https://qa.int.batchdialer.com/api/",
//         agent: {
//             firstname: "Buddy",
//             lastname: "Doe",
//             id: "XXXXXXXXXXXXXXXXX",
//             meta: { email: "test1@example.com" },
//         },
//         addonCallIntelligence: true,
//         addonCallIntelligenceOptions: {
//             trialBadge: false,
//             propertyLoad: false,
//         },
//         minimized: false,
//         darkMode: false,
//         theme: "propstream",
//     })
//     .catch(e => console.log(e))

// const speedTest = new SpeedTest();
// speedTest.on("finished", (status) => {
//     console.log("finished callback", status)
// });
// speedTest.on("progress", (status) => {
//     console.log("Testing Started", status)
// });
// speedTest.register();
// speedTest.startTest()
// const micTest = new MicTest();
// micTest.on("finished", (data) => {
//     console.log("finished callback", data)
// });
// micTest.on("error", (msg) => {
//     console.log("Error callback", msg)
// });
// micTest.register();
// setTimeout(() => {
//     micTest.startTest()

// }, 1000);
// setTimeout(() => {
//     micTest.pauseTest()
// }, 3000)
// setTimeout(() => {
//     micTest.resumeTest()
// }, 5000)
// setTimeout(() => {
//     micTest.stopTest()
// }, 10000)
